// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1h4wQ","rootSmall":"AddTileButton_rootSmall__5mh3S"};